export default function XSD_Substitution() {
  return (
    <div>
      <h1>XSD_Substitution</h1>
      <p>This is the XSD_Substitution component.</p>
    </div>
  );
}